import { get } from "lodash";
import Config from "../config.js";
import { createRequestOptions } from "./utils";

export default () =>
  Object.freeze({
    addUserActivity: async (
      userId,
      customAppId,
      activityDate,
      activityList
    ) => {
      const options = createRequestOptions({
        userId,
        customAppId,
        activityDate,
        activityList,
      });

      const result = await fetch(
        Config.mobileServerUrl + "/AddUserActivity",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    getUserActivityForCustomApp: async (userId, customAppId) => {
      const options = createRequestOptions({
        userId,
        customAppId,
      });

      const result = await fetch(
        Config.mobileServerUrl + "/GetUserActivityForCustomApp",
        options
      );
      const response = await result.json();

      return get(response, "response");
    },
    getTotalTimeInAppThisMonth: async (userId, cappId) => {
      const options = createRequestOptions({
        userId,
        cappId,
      });

      const result = await fetch(
        Config.serverUrl + "/GetTotalTimeInAppThisMonth",
        options
      );

      const response = await result.json();
      return get(response, "response");
    },
    logChartingInteraction: async (userId, cappId, lengthInSeconds) => {
      const options = createRequestOptions({
        userId,
        cappId,
        description: "portal",
        type: "RTM",
        interactionDate: new Date(),
        length: lengthInSeconds,
      });

      const result = await fetch(Config.serverUrl + "/AddInteraction", options);
      const response = await result.json();
      return get(response, "response");
    },
  });



// WEBPACK FOOTER //
// ./src/services/userActivity.js